<template>
<div class="box-labourParticulars">
    <div class="nav">
        <router-link to="Manpower"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
        工时制度
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <!-- 产假 -->
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-actve" id="active">法定节假日（带薪休假期）</h4>
                    <p id="textTitleContent">1. 元旦（1月1日）</p>
                    <p id="textTitleContent">2. 春节（农历正月初一、初二、初三）</p>
                    <p id="textTitleContent">3. 清明节（农历清明当日）</p>
                    <p id="textTitleContent">4. 劳动节（5月1日）</p>
                    <p id="textTitleContent">5. 端午节（农历端午当日）</p>
                    <p id="textTitleContent">6. 中秋节（农历中秋当日）</p>
                    <p id="textTitleContent">7. 国庆节（10月1日、2日、3日）</p>
                    <p id="textTitleContent" class="actve">8. 注：由于各部门业务节奏不同，请关注本部门或项目邮件发送的放假通知，人力资源部会依此核准考勤信息，避免旷工等异常情况的出现。</p>
                    <!-- <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg"> -->
                </div>
            </div>
            <!-- <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-actve" id="active">法定节假日（带薪休假期）</h4>
                    
                </div>
            </div> -->
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {

        };
    },
    methods: {
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "555"
                }
            })
        },
        fn() {

        }
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical", // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
  width: 100%;
  height: 100%;
}
.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    display: block;
    margin: 10px auto;
}

.contentImg {
    width: 100%;
    display: block;
    margin-top: 15px;
}
#textTitleContent{
    color: #888787;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Manpower/manpowerParticulars6.vue